export default __webpack_public_path__ + "static/media/cero.b970f375.png";